import { render } from "./HomePage.vue?vue&type=template&id=7b88e302&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=7b88e302&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Esther Ibom\\Desktop\\vue-exam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b88e302"]])

export default __exports__